import { render, staticRenderFns } from "./caseBaseDetail.vue?vue&type=template&id=e5595e7c&scoped=true"
import script from "./caseBaseDetail.vue?vue&type=script&lang=js"
export * from "./caseBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./caseBaseDetail.vue?vue&type=style&index=0&id=e5595e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5595e7c",
  null
  
)

export default component.exports